import React from 'react'

import { useQuizContext } from 'store/QuizStore'

import { Root, QuestionList, QuestionItem } from './SidePanel.styled.js'

const SidePanel = () => {
  const { questions, navDirection, selectedQuestion } = useQuizContext()

  return (
    <Root pl={[0, 40, 40, 80]}>
      <QuestionList>
        {questions.map(({ questionName }, id) => (
          <QuestionItem
            selected={selectedQuestion === id}
            mb="spaceLarge"
            fw="bold"
            color="primary"
            navDirection={navDirection}
            key={questionName}
          >
            <div>{questionName}</div>
          </QuestionItem>
        ))}
      </QuestionList>
    </Root>
  )
}

export default SidePanel
